<template lang="pug">
  div(class="m-document-cancel")
    div(class="m-document-cancel__icon")
      v-img(
        :src="require('~/assets/images/exclamation.gif')"
        max-width="80"
        width="80"
      )

    div(class="m-document-cancel__subtitle")
      h2(class="title-32px bold") {{ titleText }}
      p(class="text-14px light mb-0")
      | {{ subText }}

    div(
      v-if="!isReject"
      class="m-document-cancel__alert"
    )
      div(class="text-14px dark") {{ $t('Important') }} <br/>
      p(class="text-12px light mb-0") {{ $t('It’s impossible to squeeze this whole thing. If you need to make changes, it is better to create a new document') }}
    ValidationProvider(
      rules="required"
      :name="wrapQuotesProviderName(reasonText)"
      vid="cancellationReason"
      ref="reasonField"
      v-slot="{ errors }"
      mode="passive"
    )
      v-textarea(
        v-model="cancellationReason"
        filled
        :error-messages="errors"
        :label="reasonText"
        height="100"
        no-resize
      )
    div(class="m-document-cancel__actions")
      v-btn(
        height="48"
        @click="closeModal"
      ) {{ $t('Cancel') }}
      v-btn(
        class="main-button plain-error"
        height="48"
        :loading="loading"
        @click="confirmCancel"
      ) {{ buttonText }}
</template>

<script>
import { mapActions } from 'vuex'
import validate from '~/mixins/validation/validate'
import documentActions from '~/modules/documents/mixins/documentActions'

export default {
  name: 'MDocumentCancel',
  mixins: [validate, documentActions],
  props: {
    documentId: {
      type: [String, Number],
      required: true
    },
    closeModal: {
      type: Function,
      default: () => {}
    },
    isReject: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      cancellationReason: null
    }
  },
  computed: {
    titleText() {
      return this.isReject ? this.$t('Cancellation rejection') : this.$t('Canceling document')
    },
    subText() {
      return this.isReject
        ? this.$t(
            'The document will remain valid and all parties will be notified of your decision.'
          )
        : this.$t(
            'All subscribers will receive cancellation notices and why all participants will need to sign up'
          )
    },
    buttonText() {
      return this.isReject ? this.$t('Cancellation rejection') : this.$t('Cancel document')
    },
    reasonText() {
      return this.isReject
        ? this.$t('Enter reason of cancellation rejection')
        : this.$t('Enter reason of document cancel')
    }
  },
  methods: {
    ...mapActions('documents', ['cancelDocument']),
    async confirmCancel() {
      const isOk = await this.$refs.reasonField.validate()
      if (!isOk.valid) return
      try {
        this.loading = true
        if (this.isReject) {
          await this.$store.dispatch('documents/reject', {
            id: this.documentId,
            payload: { reason: this.cancellationReason || null }
          })
          await this.$store.dispatch('documents/read', { id: this.documentId })
        } else {
          const response = await this.cancelDocument({
            id: this.documentId,
            payload: { cancellationReason: this.cancellationReason || null }
          })

          if (response?.data) {
            this.$router.push({ name: 'documents-id', params: { id: response.data.id } })
          }
        }
        this.closeModal(true)
        this.isReject && this.rejectCancellationActSuccess()
      } catch (e) {
        this.$handlers.error(e, this)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.m-document-cancel {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  max-width: 432px;

  &__icon {
    display: flex;
    justify-content: center;
  }

  &__alert {
    border-radius: 12px;
    background: #fffbe6;
    padding: 12px 16px;
  }

  &__actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }

  & > *:not(:last-child):not(:nth-last-child(2)) {
    margin-bottom: 32px;
  }
}
</style>
